/* eslint-disable max-len */
import { useCallback, useMemo } from 'react';
import { useDeleteVariantConfiguratorOptionAssetMutation } from '../../../../api/mutations/deleteVariantConfiguratorOptionAsset';
import { useDeleteVariantConfiguratorOptionSettingAssetMutation } from '../../../../api/mutations/deleteVariantConfiguratorOptionSettingAsset';
import { useUploadVariantConfiguratorOptionAssetMutation } from '../../../../api/mutations/uploadVariantConfiguratorOptionAsset';
import { useUploadVariantConfiguratorOptionSettingAssetMutation } from '../../../../api/mutations/uploadVariantConfiguratorOptionSettingAsset';
import { VariantConfiguratorAsset } from '../../../../api/types';

const useHandleBlockAssetSave = () => {
    const [deleteAssetMutation] = useDeleteVariantConfiguratorOptionAssetMutation();
    const [uploadAssetMutation] = useUploadVariantConfiguratorOptionAssetMutation();

    const [deleteOptionSettingAssetMutation] = useDeleteVariantConfiguratorOptionSettingAssetMutation();
    const [uploadOptionSettingAssetMutation] = useUploadVariantConfiguratorOptionSettingAssetMutation();

    const uploadAsset = useCallback(
        async (variantConfiguratorId: string, blockId: string, upload: File) => {
            const { data } = await uploadAssetMutation({
                variables: {
                    id: variantConfiguratorId,
                    blockId,
                    type: VariantConfiguratorAsset.OptionsSectionImages,
                    upload,
                },
            });

            return data.variantConfigurator?.optionsBlocks;
        },
        [uploadAssetMutation]
    );

    const deleteAsset = useCallback(
        async (variantConfiguratorId: string, blockId: string, uploadId: string) => {
            const { data } = await deleteAssetMutation({
                variables: {
                    id: variantConfiguratorId,
                    blockId,
                    uploadId,
                    type: VariantConfiguratorAsset.OptionsSectionImages,
                },
            });

            return data.variantConfigurator?.optionsBlocks;
        },
        [deleteAssetMutation]
    );

    const uploadOptionSettingAsset = useCallback(
        async (variantConfiguratorId: string, blockId: string, optionSettingId: string, upload: File) => {
            const { data } = await uploadOptionSettingAssetMutation({
                variables: {
                    id: variantConfiguratorId,
                    blockId,
                    optionSettingId,
                    type: VariantConfiguratorAsset.OptionsSettingImage,
                    upload,
                },
            });

            return data.variantConfigurator?.optionsBlocks;
        },
        [uploadOptionSettingAssetMutation]
    );

    const deleteOptionSettingAsset = useCallback(
        async (variantConfiguratorId: string, blockId: string, optionSettingId: string) => {
            const { data } = await deleteOptionSettingAssetMutation({
                variables: {
                    id: variantConfiguratorId,
                    blockId,
                    optionSettingId,
                    type: VariantConfiguratorAsset.OptionsSettingImage,
                },
            });

            return data.variantConfigurator?.optionsBlocks;
        },
        [deleteOptionSettingAssetMutation]
    );

    return useMemo(
        () => ({
            uploadAsset,
            deleteAsset,
            uploadOptionSettingAsset,
            deleteOptionSettingAsset,
        }),
        [deleteAsset, uploadAsset, uploadOptionSettingAsset, deleteOptionSettingAsset]
    );
};

export default useHandleBlockAssetSave;
